



























































































// Vue
import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";
// Models
import {
  CreateOrUpdateJobDriverModel,
  JobModel,
  JobDriverModel,
  QuarryModel
} from "@/core/api/apiClient";
// Services
import AdminService from "@/views/admin/Admin.service";
// Components
import UpdateQuarryDialog from "@/views/admin/_dialogs/quarries/UpdateQuarryDialog.vue";
import JobsService from "@/views/dispatch/jobs/Jobs.service";

export default Vue.extend({
  name: "AssignQuarries",
  components: { UpdateQuarryDialog },
  props: {
    disabled: Boolean,
    job: Object as PropType<JobModel>,
    selectedDrivers: Array as PropType<JobDriverModel[]>
  },

  computed: {
    ...mapGetters({ currentUser: "currentUser" })
  },

  data() {
    return {
      dialog: false,
      isLoading: false,
      quarriesData: undefined as QuarryModel[] | undefined
    };
  },

  methods: {
    initialize(): void {
      this.getAllQuarries();

      if (!this.job) return;
    },

    getAllQuarries(): void {
      this.isLoading = true;

      AdminService.getAllQuarries(this.currentUser.clientId)
        .then((data: QuarryModel[]) => {
          if (!data) return;
          this.quarriesData = data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    submit(): void {
      // Build payload
      const payload: CreateOrUpdateJobDriverModel[] = this.selectedDrivers.map(
        (x) =>
          new CreateOrUpdateJobDriverModel({
            jobDriverId: x.jobDriverId && x.jobDriverId.trim() !== "" ? x.jobDriverId : undefined,
            driverId: x.driverId,
            quarryId: x.quarry?.quarryId ?? undefined
          })
      );
      this.isLoading = true;
      JobsService.createOrUpdateJobDrivers(this.currentUser.clientId, this.job.jobId, payload)
        .then((response: any) => {
          if (!response) return;
          this.$emit("refresh-jobs");
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    close(): void {
      this.quarriesData = undefined;
      this.dialog = false;
    }
  }
});
